<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box">
          <div class="box-body">
            <div class="row m-b-15">
              <div class="row center-block">
                <div class="col-md-12">
                  <div>
                    <br />
                    <div class="row fit gutter mx-auto">
                      <div class="col-md-6 gutter">
                        <div v-if="$route.name === 'upStoreSchedule'" class="table-row">
                          <div class="table-cell">
                            <span>店家名稱</span>
                          </div>
                          <div class="table-from">
                            <div class="form-control form-info">{{scheduleInfo.store_name}}</div>
                          </div>
                        </div>
                        <div class="table-row">
                          <div class="table-cell">
                            <span>菜單ID</span>
                          </div>
                          <div class="table-from">
                            <input v-if="!$route.query.menu_id" v-model="menuId" type="text" maxlength="45" class="form-control">
                            <div v-else class="form-control form-info">{{menuId}}</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 gutter">
                        <div class="table-row">
                          <div class="table-cell">
                            <span class="text-red">＊ </span>上架時間
                          </div>
                          <div class="table-from w-100">
                            <date-picker
                              v-model="menuTime.start.time"
                              class="hide-date-icon"
                              :show-second="false"
                              type="datetime"
                              valueType="format"
                              format="YYYY-MM-DD HH:mm:ss"
                              input-class="form-control"
                              :clearable="false"
                              :disabled-time="notBeforeTodayAddTwoMins"
                              :disabled-date="notBeforeToday"
                            />
                          </div>
                        </div>
                        <div>（更換菜單後請確認已接收預訂單是否受影響。）</div>
                      </div>
                      <div class="col-xs-12 m-x-10" v-if="$route.name === 'upSchedule' && getRoleType !== 10">
                      <div>
                        <h5>店家綁定</h5>
                        <div>
                          <div v-for="(storeClass, index) in storeClassList" class="m-r-5 m-b-10 inline-block">
                            <button class="btn btn-default" :class="{'active': curId === storeClass.id}" @click="clickOption(storeClass)">
                              {{storeClass.name}}
                            </button>
                          </div>
                        </div>
                        <!-- 參與店家 -->
                        <muti-select-two :setting="addStoresSetting" :reSet="reSet"></muti-select-two>
                      </div>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
            <div class="box-footer text-center">
              <button class="btn btn-fail" @click="$router.go(-1)">
                返回
              </button>
              <button class="btn btn-success" @click="updateInfo">
                編輯
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import $ from 'jquery'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'datatables.net'
import 'datatables.net-bs'
import moment from 'moment'
import { mapGetters } from 'vuex'
import storeListTemp from './Temp/StoreListTemp.vue'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'UpSchedule',
  extends: NdExtendHandleMenu,
  components: {
    'storelist-table': storeListTemp,
    DatePicker
  },
  data () {
    return {
      content: {
        bindingStoreList: []
      },
      storeBrief: [],
      oldScheduleTime: '',
      scheduleTime: '',
      menuTime: {
        start: {
          time: ''
        }
      },
      show: {
        back: false
      },
      name: '迷客夏',
      tableIndex: 1,
      menuId: 0,
      scheduleId: 0,
      scheduleInfo: {},
      storeId: 0,
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      info: {
        menuName: '夏日菜單',
        menu_id: 123323,
        start_time: '2017-03-31 12:22:32',
        end_time: '2017-03-31 12:22:32',
        update_time: '2017-03-31 12:22:32',
        create_time: '2017-03-31 12:22:32'
      },
      menu_schedule_list: [
        {
          'schedule_id': 122,
          'store_id': 1,
          'store_name': '金山店',
          'menu_id': 1,
          'start_time': '2017-07-24 08:00:00',
          'end_time': '2017-08-01 00:00:00',
          'status': 1,
          'update_time': '2017-01-14 16:09:16',
          'create_time': '2017-01-14 16:09:16'
        },
        {
          'schedule_id': 123,
          'store_id': 2,
          'store_name': '中山店',
          'menu_id': 2,
          'start_time': '2017-07-24 08:00:00',
          'end_time': '2017-08-01 00:00:00',
          'status': 1,
          'update_time': '2017-01-14 16:09:16',
          'create_time': '2017-01-14 16:09:16'
        }
      ],
      addStoresSetting: {
        class: 'add-store',
        options: [],
        choose: []
      },
      storeClassList: [],
      curId: 0,
      reNew: 0,
      reSet: 0
    }
  },
  created () {
    if (this.getRoleType !== 10 && !this.isStore) this.getStoreBrief()
    else {
      if (this.$route.name === 'upSchedule' || this.$route.name === 'StoreMenuScheduleEditG') {
        this.menuId = this.$route.params.menu_id
        this.getGroupSchedule()
      } else if (this.$route.params.schedule_id) {
        this.scheduleId = this.$route.params.schedule_id
        this.getSchedule()
      }
    }
  },
  mounted () {
    this.oldScheduleTime = this.scheduleTime = '2015-01-01 01:30:00 - 2015-01-02 01:30:00'
    this.$nextTick(() => {
      $('#example1_wrapper').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      })
    })
  },
  methods: {
    notBeforeToday (date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0))
    },
    notBeforeTodayAddTwoMins (date) {
      return date < new Date(moment().set('second', 0).add(5, 'm').toString())
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    getStoreBrief () {
      console.log('getStoreBrief | UpSchedule')
      this.storeBrief = []
      this.addStoresSetting.options = []
      const url = 'brand/' + this.$route.params.brand_id + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.getStoreClassList()
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            this.storeBrief.push(obj)
            this.addStoresSetting.options.push(obj)
          }
          if (this.$route.name === 'upSchedule' || this.$route.name === 'StoreMenuScheduleEditG') {
            this.menuId = this.$route.params.menu_id
            this.getGroupSchedule()
          } else if (this.$route.params.schedule_id) {
            this.scheduleId = this.$route.params.schedule_id
            this.getSchedule()
          }
        }
      })
    },
    updateInfo () {
      if (this.$route.name === 'upSchedule' || this.$route.name === 'StoreMenuScheduleEditG') {
        this.upGroupSchedule()
      } else if (this.$route.params.schedule_id) {
        this.upSchedule()
      }
    },
    upGroupSchedule () {
      if (moment() > moment(this.menuTime.start.time)) {
        this.$notify({
          title: '提醒',
          text: '上架時間逾時，請重新選擇。',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        return
      }

      let data = {
        store_id: [],
        menu_id: this.menuId,
        start_time: this.menuTime.start.time
      }
      this.addStoresSetting.choose.forEach((store) => {
        data.store_id.push(store)
      })

      if (this.getRoleType === 10) {
        data.store_id.push(this.$route.params.brand_id)
      }
      const url = this.base + this.id + '/menu/schedule/group/' + this.$route.params.group_id
      this.getDataH('put', url, data, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '更新菜單成功',
            duration: 3000,
            type: 'success',
            width: 400
          })

          let name = ''
          let params = {
            brand_id: this.$route.params.brand_id,
            store_id: ''
          }

          if (this.isStore && this.getRoleType !== 10) {
            name = 'StoreMenuSchedule'
            params.store_id = this.$route.params.store_id
          } else {
            name = 'brandScheduleTable'
          }

          this.$router.push({ name, params })
        }
      })
    },
    upSchedule () {
      console.log('upSchedule')
      const data = {
        menu_id: this.menuId,
        start_time: this.menuTime.start.time
      }
      const url = this.base + this.id + '/menu/schedule/' + this.$route.params.schedule_id
      this.getDataH('put', url, data, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '新增菜單成功',
            duration: 3000,
            type: 'success',
            width: 400
          })

          let name = ''
          let params = {
            brand_id: this.$route.params.brand_id,
            store_id: ''
          }

          if (this.isStore && this.getRoleType !== 10) {
            name = 'StoreMenuSchedule'
            params.store_id = this.$route.params.store_id
          } else {
            name = 'brandScheduleTable'
          }

          this.$router.push({ name, params })
        }
      })
    },
    getSchedule () {
      const url = this.base + this.id + '/menu/schedule/' + this.$route.params.schedule_id
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          var sInfo = response.data.schedule_info
          this.menuTime.start.time = sInfo.start_time
          this.menuId = sInfo.menu_id
          this.scheduleInfo = response.data.schedule_info
        }
      })
    },
    getGroupSchedule () {
      console.log('getGroupSchedule')
      const url = this.base + this.id + '/menu/schedule/group/' + this.$route.params.group_id
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          let gInfo = response.data.group_info
          this.menuTime.start.time = gInfo.start_time
          this.menuId = gInfo.menu_id
          gInfo.store_list.forEach((s) => {
            this.addStoresSetting.choose.push(s)
          })
        }
      })
    },
    clickOption (option) {
      var self = this
      this.addStoresSetting.options = []
      self.curId = option.id
      if (self.curId) {
        self.$nextTick(function () {
          self.reSet++
          self.addStoresSetting.options = self.storeBrief
          self.getCurStoreClass()
        })
      }
    },
    getCurStoreClass () {
      this.addStoresSetting.choose = []
      var self = this
      const url = this.base + this.id + '/storeClass/' + this.curId
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var classInfo = response.data.class
          classInfo.store_list.forEach(function (s) {
            self.addStoresSetting.choose.push(s.id)
          })
        }
      })
    },
    getStoreClassList () {
      var self = this
      const url = this.base + this.id + '/storeClassList'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          self.storeClassList = sList
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    scheduleListNew () {
      var menuList = {}
      var oldList = this.menu_schedule_list
      for (var key in oldList) {
        // console.log(oldList[key].menu_id)
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        }
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id
        })
      }
      return menuList
    },
    getList () {
      if (this.$route.name === 'upScheduleOne') {
        var oneList = this.scheduleListNew[this.menuId].storeList
        this.menuTime.start.time = oneList[0].start_time
        return oneList
      } else {
        var list = []
        for (var key in this.scheduleListNew) {
          for (var k in this.scheduleListNew[key].storeList) {
            list.push(this.scheduleListNew[key].storeList[k])
          }
        }
        return list
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  .input-group .form-control
    z-index: 1 !important
  // .ranges
    display: none
  .min-item.active, .hour-item.active, .day.checked
    background: #222d32 !important
  .w-200
    width: 180px !important
  .m-b-15
    margin-bottom: 15px !important
  .btn-all-store
    position: absolute
    right: 10px
    z-index: 30
    top: 0px
  .input-white
    border: 0px
  @media screen and (max-width: 767px)
    .p-sm-10-p
      padding-right: 10px !important
      padding-left: 10px !important
  @media screen and (min-width: 768px)
    .p-sm-10-p
      padding-right: calc(20% - 15px) !important
      padding-left: calc(20% + 10px) !important
  @media screen and (min-width: 991px)
    .p-sm-10-p
      padding-right: calc(10% - 10px) !important
      padding-left: 10% !important
</style>
<style lang="sass">
.hide-date-icon
  width: 100% !important
  .mx-icon-calendar
    display: none
@media screen and (max-width: 767px)
  .input-group.cr-schedule .cov-vue-date .cov-datepicker
    width: calc(100vw - 185px)
  @media screen and (min-width: 768px)
    .input-group.cr-schedule .cov-vue-date .cov-datepicker
      width: calc(50vw - 190px)
  @media screen and (min-width: 991px)
    .input-group .cov-vue-date .cov-datepicker
      max-width: calc(30vw - 190px)
</style>



// WEBPACK FOOTER //
// UpSchedule.vue?1be2dc6e